import { compose, lifecycle, withStateHandlers } from 'recompose'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { getAllReviews } from './selectors'


const withReview = withStateHandlers({
  ratingCount: undefined,
  reviewsCount: undefined
}, {
  setItemRatingsAndReviewsCount: () => ({ ratingCount, reviewsCount }) => ({ ratingCount, reviewsCount })
})

const withRatingsFromStore = lifecycle({
  componentDidMount() {
    const {
      allBVRatings,
      frontTire: { bvId: frontBVId = null } = {},
      bvId: bazaarVoiceId,
      setItemRatingsAndReviewsCount
    } = this.props
    const bvId = bazaarVoiceId || frontBVId
    if (bvId && allBVRatings[bvId]) {
      const { average, total } = allBVRatings[bvId]
      setItemRatingsAndReviewsCount({ ratingCount: average, reviewsCount: total })
    }
  },
  componentDidUpdate({ allBVRatings: prevAllBVRatings, bvId: prevBVId }) {
    const {
      allBVRatings,
      frontTire: { bvId: frontBVId = null } = {},
      bvId: bazaarVoiceId,
      setItemRatingsAndReviewsCount
    } = this.props
    const bvId = bazaarVoiceId || frontBVId
    const ratingsChanged = !isEqual(allBVRatings[bvId], prevAllBVRatings[prevBVId])
    if (bvId && ratingsChanged) {
      const { average = 0, total = 0 } = allBVRatings[bvId] || {}
      setItemRatingsAndReviewsCount({ ratingCount: average, reviewsCount: total })
    }
  }
})


const mapStateToProps = state => ({
  allBVRatings: getAllReviews(state)
})

export default compose(
  connect(mapStateToProps),
  withReview,
  withRatingsFromStore
)
